import React from 'react';

const ProfileEdit = ({ 
   isOpen, onClose, onSubmit, editDetails, handleInputChange, 
   onLogoChange, onFaviconChange, 
   logoImage, faviconImage, onRemoveLogo, onRemoveFavicon,
   isSubmitting 
}) => {
   if (!isOpen) return null;

   const logoPreview = logoImage ? URL.createObjectURL(logoImage) : editDetails.restaurantLogo;
   const faviconPreview = faviconImage ? URL.createObjectURL(faviconImage) : editDetails.restaurantFavicon;

   return (
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-slate-900/60 backdrop-blur-sm p-4">
         <div className="relative bg-white rounded-3xl border border-slate-100 shadow-2xl max-w-xl w-full overflow-hidden animate-scale-up" data-aos="zoom-in">
            
            {/* Modal Header */}
            <div className="bg-slate-50 px-6 py-5 border-b border-slate-100 flex items-center justify-between">
               <h2 className="text-xl font-black text-slate-800 tracking-tight">Edit Profile & Settings</h2>
               <button 
                  onClick={onClose} 
                  className="text-slate-400 hover:text-slate-700 transition font-bold text-sm"
               >
                  ✕
               </button>
            </div>

            <form onSubmit={onSubmit} className="p-6 space-y-6">
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Restaurant Name</label>
                     <input
                        type="text"
                        name="shop_type"
                        value={editDetails.shop_type || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                     />
                  </div>

                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Address</label>
                     <input
                        type="text"
                        name="address"
                        value={editDetails.address || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                     />
                  </div>

                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Owner Name</label>
                     <input
                        type="text"
                        name="owner"
                        value={editDetails.owner || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                     />
                  </div>

                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Mobile Number</label>
                     <input
                        type="text"
                        name="mobile"
                        value={editDetails.mobile || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                     />
                  </div>

                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Email Address</label>
                     <input
                        type="email"
                        name="email"
                        value={editDetails.email || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                     />
                  </div>

                  <div>
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">UPI ID for Payments</label>
                     <input
                        type="text"
                        name="upiId"
                        value={editDetails.upiId || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition font-mono"
                        placeholder="UPI ID Not Set"
                     />
                  </div>

                  <div className="md:col-span-2">
                     <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1">Public Contact Number <span className="text-teal-600 font-bold normal-case tracking-normal">(shown on receipts &amp; customer pages)</span></label>
                     <div className="relative">
                        <input
                           type="text"
                           name="publicMobile"
                           value={editDetails.publicMobile || ""}
                           onChange={handleInputChange}
                           className="w-full px-4 py-2.5 border border-teal-200 bg-teal-50/40 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                           placeholder={`Leave blank to use login number: ${editDetails.mobile || ""}`}
                        />
                     </div>
                     <p className="text-[11px] text-slate-400 font-semibold mt-1.5 flex items-center gap-1">
                        📞 If left blank, your registered login number will appear on all receipts and public pages.
                     </p>
                  </div>
               </div>

               {/* Opening Hours */}
               <div className="border-t border-slate-100 pt-4">
                  <h3 className="text-sm font-bold text-slate-800 mb-3 flex items-center gap-1.5">
                     🕜 Operating Hours Settings
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                     <div>
                        <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Monday - Friday</label>
                        <input
                           type="text"
                           name="openingHours.mondayFriday"
                           value={editDetails.openingHours?.mondayFriday || ""}
                           onChange={handleInputChange}
                           className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                           placeholder="e.g. 09:00 AM - 11:00 PM"
                        />
                     </div>
                     <div>
                        <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Saturday - Sunday</label>
                        <input
                           type="text"
                           name="openingHours.saturdaySunday"
                           value={editDetails.openingHours?.saturdaySunday || ""}
                           onChange={handleInputChange}
                           className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm font-semibold transition"
                           placeholder="e.g. 10:00 AM - 11:30 PM"
                        />
                     </div>
                  </div>
               </div>

               {/* Order Capabilities */}
               <div className="border-t border-slate-100 pt-4">
                  <h3 className="text-sm font-bold text-slate-800 mb-3 flex items-center gap-1.5">
                     🚀 Order Capabilities
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                     <label className="flex items-center gap-2 text-sm font-semibold text-slate-600 cursor-pointer">
                        <input
                           type="checkbox"
                           name="orderCapabilities.dineInEnabled"
                           checked={editDetails.orderCapabilities?.dineInEnabled !== false}
                           onChange={handleInputChange}
                           className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                        />
                        Enable Dine-In
                     </label>
                     <label className="flex items-center gap-2 text-sm font-semibold text-slate-600 cursor-pointer">
                        <input
                           type="checkbox"
                           name="orderCapabilities.takeawayEnabled"
                           checked={editDetails.orderCapabilities?.takeawayEnabled !== false}
                           onChange={handleInputChange}
                           className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                        />
                        Enable Takeaway
                     </label>
                     <label className="flex items-center gap-2 text-sm font-semibold text-slate-600 cursor-pointer">
                        <input
                           type="checkbox"
                           name="orderCapabilities.deliveryEnabled"
                           checked={editDetails.orderCapabilities?.deliveryEnabled === true}
                           onChange={handleInputChange}
                           className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                        />
                        Enable Delivery
                     </label>
                  </div>
               </div>

               {/* Branding / Images */}
               <div className="border-t border-slate-100 pt-4">
                  <h3 className="text-sm font-bold text-slate-800 mb-3 flex items-center gap-1.5">
                     🖼️ Restaurant Branding
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                     <div>
                        <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Restaurant Logo (Max 2MB)</label>
                        <div className="flex items-center gap-4">
                           {logoPreview && (
                              <div className="relative w-16 h-16 rounded-xl border border-slate-200 overflow-hidden bg-slate-50 flex-shrink-0 shadow-sm">
                                 <img src={logoPreview} alt="Logo Preview" className="w-full h-full object-contain p-1" />
                              </div>
                           )}
                           <div className="flex-1">
                              <input
                                 key={logoImage ? logoImage.name : 'empty-logo'}
                                 type="file"
                                 accept="image/*"
                                 onChange={onLogoChange}
                                 className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm text-slate-600 transition file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
                              />
                              {logoPreview && (
                                 <button type="button" onClick={onRemoveLogo} className="mt-2 text-xs text-red-500 hover:text-red-700 font-bold transition flex items-center gap-1">
                                    <span className="text-lg leading-none">×</span> Remove Logo
                                 </button>
                              )}
                           </div>
                        </div>
                     </div>
                     <div>
                        <label className="block text-xs font-black uppercase tracking-wider text-slate-500 mb-1.5">Favicon (Max 500KB)</label>
                        <div className="flex items-center gap-4">
                           {faviconPreview && (
                              <div className="relative w-16 h-16 rounded-xl border border-slate-200 overflow-hidden bg-slate-50 flex-shrink-0 shadow-sm">
                                 <img src={faviconPreview} alt="Favicon Preview" className="w-full h-full object-contain p-2" />
                              </div>
                           )}
                           <div className="flex-1">
                              <input
                                 key={faviconImage ? faviconImage.name : 'empty-favicon'}
                                 type="file"
                                 accept=".ico,.png,.svg"
                                 onChange={onFaviconChange}
                                 className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm text-slate-600 transition file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
                              />
                              {faviconPreview && (
                                 <button type="button" onClick={onRemoveFavicon} className="mt-2 text-xs text-red-500 hover:text-red-700 font-bold transition flex items-center gap-1">
                                    <span className="text-lg leading-none">×</span> Remove Favicon
                                 </button>
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               {/* Footer Action Buttons */}
               <div className="flex justify-end gap-2.5 border-t border-slate-100 pt-5">
                  <button
                     type="button"
                     onClick={onClose}
                     className="px-5 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-sm font-black transition duration-200"
                  >
                     Cancel
                  </button>
                  <button
                     type="submit"
                     className="px-6 py-2.5 bg-slate-900 hover:bg-black text-white rounded-xl text-sm font-black transition duration-200 shadow-md"
                     disabled={isSubmitting}
                  >
                     {isSubmitting ? 'Saving...' : 'Save Updates'}
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default ProfileEdit;
